import { parseWithZod } from '@conform-to/zod'
import { invariantResponse } from '@epic-web/invariant'
import { data, redirect } from 'react-router'
import { z } from 'zod'
import { type Theme, setTheme } from '#app/utils/theme.server.ts'
import { type Route } from './+types/theme-switch.ts'

const ThemeFormSchema = z.object({
	theme: z.enum(['system', 'light']),
	// this is useful for progressive enhancement
	redirectTo: z.string().optional(),
})

export async function action({ request }: Route.ActionArgs) {
	const formData = await request.formData()
	const submission = parseWithZod(formData, {
		schema: ThemeFormSchema,
	})

	invariantResponse(submission.status === 'success', 'Invalid theme received')

	const { theme, redirectTo } = submission.value

	const responseInit = {
		headers: { 'set-cookie': setTheme(theme) },
	}
	if (redirectTo) {
		return redirect(redirectTo, responseInit)
	} else {
		return data({ result: submission.reply() }, responseInit)
	}
}

/**
 * Theme switch is disabled - dark mode is not available
 * This component is kept for backwards compatibility but renders nothing
 */
export function ThemeSwitch({
	userPreference: _userPreference,
}: {
	userPreference?: Theme | null
}) {
	// Dark mode is disabled - render nothing
	return null
}

/**
 * Dark mode is disabled - always returns undefined
 */
export function useOptimisticThemeMode() {
	return undefined
}

/**
 * Dark mode is disabled - always returns 'light'
 */
export function useTheme(): 'light' {
	return 'light'
}

/**
 * Dark mode is disabled - always returns 'light'
 */
export function useOptionalTheme(): 'light' {
	return 'light'
}
